import React, { createContext, useState, useContext, useEffect } from 'react';

const BibliotecaContext = createContext();

export const useBibliotecaContext = () => {
    return useContext(BibliotecaContext);
};

export const BibliotecaProvider = ({ children }) => {

    const [normasData, setNormasData] = useState({ normas: [] });
    const [estadosData, setEstadosData] = useState(null);
    const [municipiosData, setMunicipiosData] = useState(null);
    const [impostosData, setImpostosData] = useState(null);
    const [segmentosData, setSegmentosData] = useState(null);
    const [sumariosData, setSumariosData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [expandedId, setExpandedId] = useState(null);
    const [dateStart, setDateStart] = useState("");
    const [dateEnd, setDateEnd] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [estadosSelecionados, setEstadosSelecionados] = useState([]);
    const [municipiosSelecionados, setMunicipiosSelecionados] = useState([]);
    const [impostosSelecionados, setImpostosSelecionados] = useState([]);
    const [numeroDaLei, setNumeroDaLei] = useState('');
    const [filtroAberto, setFiltroAberto] = useState('');
    const [ncm, setNcm] = useState('');
    const [segmentosSelecionados, setSegmentosSelecionados] = useState([]);
    const [sumariosSelecionados, setSumariosSelecionados] = useState([]);
    const [normasInformadas, setNormasInformadas] = useState(0);
    const [isSmartSearchOpen, setIsSmartSearchOpen] = useState(false);
    const [page, setPage] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(5);
    const [hasMore, setHasMore] = useState(true);
    const [isOn, setIsOn] = useState(0);

    useEffect(() => {
        const now = new Date();

        const startDate = now.toISOString().split("T")[0];

        const pastDate = new Date();
        pastDate.setFullYear(pastDate.getFullYear() - 1);
        const endDate = pastDate.toISOString().split("T")[0];

        setDateStart(startDate);
        setDateEnd(endDate);
    }, []);

    return (
        <BibliotecaContext.Provider value={
            {
                normasData, setNormasData,
                estadosData, setEstadosData,
                municipiosData, setMunicipiosData,
                impostosData, setImpostosData,
                segmentosData, setSegmentosData,
                sumariosData, setSumariosData,
                loading, setLoading,
                error, setError,
                expandedId, setExpandedId,
                dateStart, setDateStart,
                dateEnd, setDateEnd,
                searchQuery, setSearchQuery,
                estadosSelecionados, setEstadosSelecionados,
                municipiosSelecionados, setMunicipiosSelecionados,
                impostosSelecionados, setImpostosSelecionados,
                numeroDaLei, setNumeroDaLei,
                filtroAberto, setFiltroAberto,
                ncm, setNcm,
                segmentosSelecionados, setSegmentosSelecionados,
                sumariosSelecionados, setSumariosSelecionados,
                normasInformadas, setNormasInformadas,
                isSmartSearchOpen, setIsSmartSearchOpen,
                page, setPage,
                itemsPerPage, setItemsPerPage,
                hasMore, setHasMore,
                isOn, setIsOn,
            }
        }>
            {children}
        </BibliotecaContext.Provider>
    );
};
